<template>
    <div class="container" :style="{backgroundImage:'url('+require('@/assets/images/main-bg.png')+')'}">
        <div class="header">
            <img :src="require('@/assets/images/header.png')" alt="header" />
        </div>
        <div class="box">
            <div class="number" :style="{backgroundImage:`url(${require('@/assets/images/number-bg.png')})`}">
                参赛序号：{{ content.id }}
            </div>
            <div class="item-box">
                <div class="item-outer">
                    <div class="item">
                        <div class="item-content">
                            <div class="title">{{ content.title }}</div>
                            <div class="vote">当前票数：<span>{{ content.votenum }}票</span></div>
                            <div class="item-divider"></div>
                            <div class="item-image-wrap">
                                <img class="item-images" :src="content.zuopin" alt="" @click="showPreview">
                            </div>
                            <div class="author" v-if="content.author">作者：{{ content.author }}</div>
                            <div class="html" v-if="content.content" v-html="content.content"></div>
                            <div class="empty" v-else>暂无作品介绍</div>
                        </div>
                    </div>
                    <div class="vote-button" :style="{backgroundImage:'url('+require('@/assets/images/vote-number.png')+')'}">
                        <div class="d1" @click="changeVote(content.id)">投一票</div>
                    </div>
                </div>
            </div>
        </div>
        <van-overlay :show="captcha" @click="captcha=false">
          <div id="embed-captcha"></div>
        </van-overlay>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { ImagePreview} from "vant";
import $ from 'jquery'
import "@/assets/js/gt"

export default {
  name: 'Content',
  data () {
    return {
      content: [],
      voteing: false,
      captcha: false,
      starDate:'',
      endDate:'',
    }
  },
  mounted () {
    this.getVoteTime();
    this.getContent()
  },
  methods: {
    getVoteTime() {
      let that = this
      that.$api.get('/default/voteTime').then(function (res) {
        if (res.data.code === 0 && res.data.data) {
          that.starDate = res.data.data.vote_start_date || '';
          that.endDate = res.data.data.vote_end_date || '';
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
  //预览图片
  showPreview(){
      ImagePreview([this.content.zuopin],0,{
          closeable:true
      })
  },
    changeVote(id) {
      $("#embed-captcha").html('')
        if (this.isVotingTime()){
            this.id = id;
            this.captcha = true;
            this.initGT()
        }

    },

  //判断是否在投票的时间段
  isVotingTime(){
      const now = new Date();
      const startDate = new Date(this.starDate);
      const endDate = new Date(this.endDate);
      console.log(now)
      console.log(startDate)
      console.log(now < startDate)
      if (now < startDate) {
          console.log('未到投票时间');
          Toast.success('未到投票时间！');
          return false;

      }else if(now > endDate){
          console.log('投票已结束')
          Toast.success('投票已结束！');
          return false;
      } else {
          console.log('可以投票')
          return true;
      }

  },

    doVote(validate) {
      console.log(validate)
      let that = this
      if(that.voteing){
        return false;
      }
      that.voteing = true;
      validate.id = that.id
      that.$api.post('/default/addVote', validate).then(function (response) {
        console.log(response)
        that.voteing = that.captcha = false;
        if (response.data.code === 0) {
          Toast.success('投票成功！');
        } else {
          Toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        that.voteing = false;
        Toast.fail(error);
      });
    },
    getContent() {
      let that = this
      this.$api.get('/default/info/'+that.$route.params.id).then(function (response) {
        console.log(response)
        if (response.data.code === 0) {
            that.content = response.data.data
        } else {
            Toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
        Toast.fail(error);
      });
    },
    initGT(){
      var that = this
      that.$api.get('/default/geetestReg?t='+(new Date()).getTime()).then(res=>{
        let data=res.data.data
        // data.new_captcha = 1
        // eslint-disable-next-line no-undef
        initGeetest({
          gt: data.gt,
          challenge: data.challenge,
          // new_captcha: 1, // 用于宕机时表示是新验证码的宕机
          offline: !data.success, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          product: "bind", // 产品npm形式，包括：float，popup
          width: "100%"
        }, function (captchaObj) {
          // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
          captchaObj.appendTo("#embed-captcha");
          captchaObj.onReady(function(){
            console.log(111)
          }).onSuccess(function(){
            var validate = captchaObj.getValidate();
            that.doVote(validate)
          }).onError(function(){
            console.log(333)
          })
        });
      })
    },
  },
}
</script>

<style scoped>
  .header{width: 100%;display: block;}
  .header img{width:100%;display:block;height:auto;}
  .container{background-size:100% 100%;background-repeat:no-repeat;min-height: 100vh;}
  .box{padding:30px 10px 50px 20px;position: relative; margin-top: 50px;}
  .item-box{width:100%;}
  .item-outer{background: #fff;border-radius: 12px;box-shadow: 0 4px 20px rgba(0,0,0,0.1);overflow: hidden;padding: 15px 12px;}
  .item{position: relative;}
  .back{width:70px;position: absolute;top: 10px;left: 10px;z-index: 10;}
  .item-content{padding: 60px 20px 20px 20px;}
  .number{width:335px;height:80px;line-height:80px;background-size: 100% 100%;background-repeat: no-repeat;font-size:30px;font-weight: bold;text-align: center;position: absolute;left:50%;top:-10px;transform: translateX(-50%);z-index: 10;color:#fff;text-shadow: #333 3px 0 0, #333 0 3px 0, #333 -3px 0 0, #333 0 -3px 0;}
  .title{font-size:40px;padding:0 30px;color:#333;font-weight: 600;text-align: center;}
  .vote{font-size:26px;padding:0 30px;color:#737374;margin-top:20px;text-align: center;}
  .vote span{color:#F48503;font-weight: 600;}
  .item-divider{height: 1px;background: #e5e5e5;margin: 20px 0;}
  .item-image-wrap{position: relative;width:100%;padding-bottom: 120%;margin-bottom: 20px;}
  .item-images{position: absolute;top: 0;left: 0;width:100%;height:100%;object-fit: cover;border-radius: 8px;}
  .author{font-size:28px;color:#666;padding: 20px 0;text-align: center;background: #f5f5f5;border-radius: 8px;margin-bottom: 20px;}
  .html{font-size:28px;color:#494949;line-height: 1.6;}
  .empty{font-size:24px;color:#666;text-align: center;padding: 40px 0;}
  .vote-button{width:260px;height:80px;font-size:20px;color:#fff;text-align: center;position: relative;background-size: 100% 100%;margin: 30px auto 20px;display: flex;flex-direction: column;justify-content: center;align-items: center;border-radius: 10px;}
  .vote-button .d1{font-size:30px;font-weight: bold;}
  #embed-captcha{left:100px;top:40%;position: absolute;z-index: 100;}
  .van-overlay{z-index: 99;}
</style>